// Blinks an emoji prefix in front of the tab's own title while a request is
// pending: hidden for HIDDEN_MS, showing "<emoji> <original title>" for
// SHOWN_MS, repeating — the title itself is never replaced.

const HIDDEN_MS = 500;
const SHOWN_MS = 1500;

let originalTitle = null;
let timer = null;
let showing = false;

function scheduleNext(emoji) {
    timer = setTimeout(() => {
        showing = !showing;
        document.title = showing ? `${emoji} ${originalTitle}` : originalTitle;
        scheduleNext(emoji);
    }, showing ? SHOWN_MS : HIDDEN_MS);
}

/**
 * (Re)starts the blink with the given emoji — safe to call again while
 * already running (e.g. a call replacing a message's prefix) since it always
 * restarts from the true original title rather than the currently blinking one.
 */
export function startTitleBlink(emoji) {
    if (timer === null) originalTitle = document.title;
    clearTimeout(timer);
    showing = false;
    document.title = originalTitle;
    scheduleNext(emoji);
}

export function stopTitleBlink() {
    if (timer === null) return;
    clearTimeout(timer);
    timer = null;
    if (originalTitle !== null) document.title = originalTitle;
    originalTitle = null;
    showing = false;
}
